import { Layout, Menu } from 'antd';
import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Brand } from '../header/header-components';
import { subMenu } from './config';
import './sidebar.scss';
import { useAppSelector } from 'app/config/store';
import { hasAnyPermissions } from 'app/shared/util/permissions';
const { Sider } = Layout;

export interface IHeaderProps {
  isAuthenticated: boolean;
  isAdmin: boolean;
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
}

const SideBar = (props: IHeaderProps) => {
  const location = useLocation();

  const { selectedKeys, openKeys } = useMemo(() => {
    const pathname = location.pathname || '';
    let selected: string | undefined;
    let open: string | undefined;

    subMenu.forEach(sub => {
      if (sub.linkTo && pathname.startsWith(sub.linkTo)) {
        selected = `${sub.key}`;
      }
      if (!selected && sub.items) {
        sub.items.forEach(item => {
          if (pathname.startsWith(item.linkTo)) {
            selected = `${sub.key}_${item.key}`;
            open = `${sub.key}`;
          }
        });
      }
    });

    return {
      selectedKeys: selected ? [selected] : [],
      openKeys: open ? [open] : [],
    };
  }, [location.pathname]);

  const renderSubMenu = sub => {
    const isPermissions = hasAnyPermissions(props.isAdmin, sub.key);
    if (!isPermissions) return;
    if (sub.linkTo) {
      return (
        <Menu.Item icon={sub.icon} key={`${sub.key}`}>
          <Link className="item-router" to={sub.linkTo}>
            {sub.title}
          </Link>
        </Menu.Item>
      );
    }
    return (
      <Menu.SubMenu icon={sub.icon} key={sub.key} title={sub.title}>
        {sub.items?.map(subItem => {
          const isPermissionSubs = hasAnyPermissions(props.isAdmin, subItem.key);
          if (!isPermissionSubs) return;
          return (
            <Menu.Item key={`${sub.key}_${subItem.key}`}>
              <Link className="item-router" to={subItem.linkTo}>
                {subItem.title}
              </Link>
            </Menu.Item>
          );
        })}
      </Menu.SubMenu>
    );
  };
  return (
    <Sider width={250} className="menu" trigger={null} collapsible collapsed={props.collapsed}>
      <Brand />
      <Menu theme="dark" mode="inline" selectedKeys={selectedKeys} defaultOpenKeys={openKeys}>
        {subMenu.map(sub => renderSubMenu(sub))}
      </Menu>
    </Sider>
  );
};

export default SideBar;
